import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

import { AuthFormShell } from '@/components/PageHeader';
import { AuthLayout } from '@/layouts/AuthLayout';

export default function RequestSentPage() {
  const { t } = useTranslation();

  return (
    <AuthLayout hideFooter>
      <title>{t('signup.requestSent.title')}</title>

      <AuthFormShell
        title={t('signup.requestSent.title')}
        description={t('signup.requestSent.description')}
      >
        <div className="flex flex-col items-center">
          <CheckCircle2 className="mb-6 size-16 text-success" />
        </div>
      </AuthFormShell>
    </AuthLayout>
  );
}
